import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { iconColors } from '@app/shared/constants';
import { SidebarMenuContainer } from 'src/app/modules/common-features/sidebar/models/sidebar-menu-container.model';
import { SidebarMenuItem } from 'src/app/modules/common-features/sidebar/models/sidebar-menu-item.model';
import { LayoutService } from 'src/app/shared/services/layout.service';
import { ResponsiveService } from 'src/app/shared/services/responsive.service';

@Component({
  selector: 'sidebar-menu-container',
  templateUrl: './sidebar-menu-container.component.html',
  styleUrls: ['./sidebar-menu-container.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SidebarMenuContainerComponent implements OnInit {
  @Input()
  public item: SidebarMenuContainer;

  @Input()
  public isCollapsed: boolean;

  private _subMenuItems: Array<SidebarMenuItem>;

  public iconColors = iconColors;
  public isHovered = false;
  public isMobileDevice = false;

  public get subMenuItems(): Array<SidebarMenuItem> {
    if (!this._subMenuItems) {
      this._subMenuItems = this.item.sublings
        .filter((s) => s instanceof SidebarMenuItem)
        .map((s) => s as SidebarMenuItem);
    }

    return this._subMenuItems;
  }

  constructor(private readonly responsiveService: ResponsiveService, private readonly layoutService: LayoutService) {}

  public ngOnInit(): void {
    this.item.expanded = this.layoutService.isSidebarOpen && this.subMenuItems.some((x) => x.isActive());
    this.isMobileDevice = this.responsiveService.isMobileWidth() && this.responsiveService.isTouchscreen();
  }

  public onOutsideClick(): void {
    if (!this.layoutService.isSidebarOpen) {
      this.item.expanded = false;
    }
  }

  public toggleExpand(): void {
    if (!this.item.expanded) {
      this.layoutService.sidebarComponent.closeAllContainers();
    }

    this.item.expanded = !this.item.expanded;
  }

  public isActive(): boolean {
    return this.item.expanded || this.subMenuItems.some((i) => i.isActive());
  }

  public onSubItemClick(item: SidebarMenuItem): void {
    item.action();

    if (!item.disableCollapse) {
      this.layoutService.sidebarComponent.closeAllContainers();
    }

    this.item.expanded = this.layoutService.isSidebarOpen;

    if (this.responsiveService.isMobileWidth()) {
      this.layoutService.closeSidebar();
    }
  }
}
